<template>
  <div>
    <div class="headerNav">
      <div class="nav">
        <div class="nav_content">注册</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left_b.svg" alt="" /></div>
    </div>
    <div class="loginBox">
      <div class="t1">用户注册</div>
      <div class="t2">铜仁学院省级专业技术人员继续教育培训平台</div>
        <div style="color: red;margin-top: 10rpx;font-size: 14px;" v-if="this.$route.query.userId">欢迎参加平台福利活动，请在当前页面完成用户注册操作，离开当前页面则活动无效</div>

      <div class="userInfo">
        <div class="u1">手机号码</div>
        <div>
          <van-field type="number" v-model="userInfo.mobile" class="u2" placeholder="请输入您的手机号码" @blur="vaPhone(1)" />
        </div>

        <div class="u1">验证码</div>
        <div class="yzBox">
          <van-field type="number" v-model="userInfo.smsCode" class="u2 yzm" placeholder="请输入验证码" />

          <div class="yzBtn" @click="captCimgCode">{{ codeText }}</div>
        </div>
        <div class="u1">密码</div>
        <div>
          <van-field type="password" v-model="userInfo.password" class="u2" placeholder="请输入您的密码" @blur="vaPhone(2)" />
        </div>
        <div class="u1">姓名</div>
        <div>
          <van-field type="text" v-model="userInfo.realname" class="u2" placeholder="请输入您的姓名" />
        </div>
        <div class="u1">身份证号</div>
        <div>
          <van-field type="text" v-model="userInfo.cardNo" class="u2" placeholder="请输入您的身份证号" @blur="vaPhone(3)" />
        </div>
        <div class="u1">地区</div>
        <div>
          <van-field class="u2" v-model="cascaderValue" is-link readonly placeholder="请选择所在地区" @click="show = true" />
        </div>
      </div>

      <div class="btn" @click="login">立即注册</div>

      <div class="zc">
        <van-checkbox v-model="checked" icon-size="12px"
          >注册即同意<span style="color: #4076f6" @click="xy">《铜仁学院省级专业技术人员继续教育培训平台注册协议》</span></van-checkbox
        >
      </div>
    </div>

    <van-popup v-model="showImgCode" closeable :close-on-click-overlay="false" round>
      <div class="imgCodeBox">
        <div class="i1">验证码认证</div>

        <div class="imgCodeFlex">
          <div class="imgCode">
            <img :src="'data:image/png;base64,' + codeImg" alt="" />
          </div>
          <div class="sx">
            <div @click="getImgCode">
              <div class="sxImg"><img src="../../assets/images/sx.png" alt="" /></div>
              <div class="sxt">刷新</div>
            </div>
          </div>
        </div>
        <div class="imgCodeInput">
          <input type="text" class="codeInput" v-model="codeValue" placeholder="请输入图片验证码" />
        </div>

        <div class="qd" @click="submitCode">确定</div>
      </div>
    </van-popup>

    <van-popup v-model="show" round position="bottom">
      <van-cascader
        v-model="userInfo.area"
        title="请选择所在地区"
        :options="options"
        @close="show = false"
        @finish="onFinish"
        :field-names="fieldNames"
      />
    </van-popup>

    <van-popup v-model="registerXy" style="width: 90%; height: 80%; padding: 20px" round closeable>
      <registerXy></registerXy>
    </van-popup>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { doRegister, toArea, sendDx, toOnlyUser, captchaImage, checkCatchCode, isMobile } from '@/api/login.js';
import { mapMutations } from 'vuex';
import registerXy from '../registerXy/registerXy';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    registerXy
  },
  data() {
    // 这里存放数据
    return {
      fieldNames: {
        text: 'cityName',
        value: 'codeId',
        children: 'children'
      },
      userInfo: {
        mobile: ''
      },
      showImgCode: false,
      show: false,
      cascaderValue: '',
      codeImg: '',
      codeValue: '',
      uuid: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [],
      codeText: '获取验证码',
      tiemr: 60,
      sucessImgCode: false,
      falg: true,
      checked: false,
      phoneFalg: false, //true为号码已被注册无法获取验证码
      psd: false,
      card: false,
      ph: false,
      cardVa: false,
      regFalg: false, //true为无法注册
      registerXy: false,
      pcRegisterUrl: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),
    //用户注册协议
    xy() {
      this.registerXy = true;
      // this.$router.push('/registerXy')
    },
    //返回上一级
    goBack() {
      if (this.$route.query.userId) {
        this.$router.push('/');
      } else {
        this.$router.go(-1);
      }
    },
    //判断是否是移动端
    getMobile() {
      if (this.$route.query.userId) {
        isMobile({ userId: this.$route.query.userId }).then(res => {
          if (res.data.code == 200) {
            this.pcRegisterUrl = res.data.data.pcRegisterUrl;
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (!isMobile) {
              window.location.href = this.pcRegisterUrl;
            }
          }
        });
      }
    },
    //获取图片验证码
    captCimgCode() {
      if (this.userInfo.mobile == '' || this.userInfo.mobile == undefined) {
        this.$utils.showToast('请输入手机号码！');
        return false;
      }
      if (this.phoneFalg) {
        this.$utils.showToast('手机号码已被注册！');
        return false;
      }
      if (this.sucessImgCode) {
        this.getPhoneCode();
      } else {
        this.getImgCode();
      }
    },
    //图片验证码
    getImgCode() {
      captchaImage().then(res => {
        this.codeImg = res.data.img;
        this.uuid = res.data.uuid;
        this.showImgCode = true;
        this.codeValue = '';
      });
    },
    //校验图片验证码获取手机验证码
    submitCode() {
      let data = {
        uuid: this.uuid,
        code: this.codeValue
      };
      checkCatchCode(data).then(res => {
        if (res.data.code == 200) {
          //关闭弹框
          //验证成功之后不需要再次验证了
          this.sucessImgCode = true;
          //校验成功发送验证码
          this.getPhoneCode();
        } else {
          this.$utils.showToast(res.data.msg);
        }
      });
    },
    //发送手机验证码
    getPhoneCode() {
      console.log(this.falg);
      if (!this.falg) {
        return false;
      }
      this.falg = false;
      let data = {
        mobile: this.userInfo.mobile
      };
      sendDx(data).then(mow => {
        console.log(mow.data.code);
        if (mow.data.code == 200) {
          this.showImgCode = false;
          this.tiemr = 60;
          var ste = setInterval(() => {
            this.tiemr = this.tiemr - 1;
            this.codeText = '已发送 ' + this.tiemr;

            if (this.tiemr <= 0) {
              clearInterval(ste);
              this.codeText = '重新发送';
              this.falg = true;
            }
          }, 1000);
        } else {
          this.falg = true;
          this.$utils.showToast(mow.data.msg);
        }
      });
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      console.log(selectedOptions);

      this.show = false;
      this.cascaderValue = selectedOptions.map(option => option.cityName).join('-');
      this.userInfo.area = selectedOptions[selectedOptions.length - 1].codeId;
      console.log(this.userInfo.area);
    },
    ...mapMutations('m_user', ['updateToken']),
    login() {
      if (this.userInfo.mobile == '' || this.userInfo.mobile == undefined) {
        this.$utils.showToast('请输入手机号码！');
        return false;
      } else if (this.userInfo.smsCode == '' || this.userInfo.smsCode == undefined) {
        this.$utils.showToast('请输入验证码！');
        return false;
      } else if (this.userInfo.password == '' || this.userInfo.password == undefined) {
        this.$utils.showToast('请输入密码！');
        return false;
      } else if (this.userInfo.realname == '' || this.userInfo.realname == undefined) {
        this.$utils.showToast('请输入姓名！');
        return false;
      } else if (this.userInfo.cardNo == '' || this.userInfo.cardNo == undefined) {
        this.$utils.showToast('请输入身份证号！');
        return false;
      } else if (this.userInfo.area == '' || this.userInfo.area == undefined) {
        this.$utils.showToast('请选择所在地区！');
        return false;
      }
      if (this.ph) {
        this.$utils.showToast('请填写正确的手机号码');
        return false;
      }
      if (this.psd) {
        this.$utils.showToast('密码最低为六位！');
        return false;
      }
      if (this.cardVa) {
        this.$utils.showToast('请填写正确的身份证号码!');
        return false;
      }
      if (this.card) {
        this.$utils.showToast('身份证号码已被注册！');
        return false;
      }
      if (!this.checked) {
        this.$utils.showToast('请勾选用户注册协议！');
        return false;
      }
      if (this.regFalg) {
        this.$utils.showToast('按钮点击过快，请5s后重试~');
        return false;
      }
      this.regFalg = true;
      setTimeout(() => {
        //5s内只能点击一次
        this.regFalg = false;
      }, 5000);
      if (this.$route.query.userId) {
        this.userInfo.userId = this.$route.query.userId;
      } else {
        this.userInfo.userId = '';
      }
      console.log(this.userInfo.userId);

      this.userInfo.equipment = '02';
      doRegister(this.userInfo).then(res => {
        console.log(res.data);
        if (res.data.code == '200') {
          this.updateToken(res.data.data.token);
          // 拿到密钥存在本地存储
          localStorage.setItem('token', res.data.data.token);
          this.$utils.showToast('注册成功');
          setTimeout(() => {
            this.$router.push('/my');
          }, 1000);
        } else {
          this.$utils.showToast(res.data.msg);
        }
      });
    },

    //获取地区
    getToArea() {
      toArea({ parent:52 }).then(res => {
        console.log(res.data.data);
        this.options = res.data.data;
      });
    },
    //校验
    vaPhone(type) {
      if (type == 1) {
        var str = this.userInfo.mobile;
        var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(str)) {
          this.$utils.showToast('请填写正确的手机号码');
          this.ph = true;
          return false;
        } else {
          this.ph = false;
          let data = {
            mobile: this.userInfo.mobile
          };
          toOnlyUser(data).then(res => {
            if (res.data.data) {
              this.$utils.showToast('手机号码已被注册！');
              this.phoneFalg = true;
            } else {
              this.phoneFalg = false;
            }
          });
        }
      } else if (type == 2) {
        if (this.userInfo.password.length < 5) {
          this.$utils.showToast('密码最低为六位！');
          this.psd = true;
        } else {
          this.psd = false;
        }
      } else if (type == 3) {
        var str = this.userInfo.cardNo;
        var reg = /\d{17}[\d|x|X]|\d{15}/;
        if (!reg.test(str)) {
          this.$utils.showToast('请填写正确的身份证号码!');
          this.cardVa = true;
          return false;
        } else {
          this.cardVa = false;
          let data = {
            cardNo: this.userInfo.cardNo
          };
          toOnlyUser(data).then(res => {
            if (res.data.data) {
              this.$utils.showToast('身份证号码已被注册！');
              this.card = true;
            } else {
              this.card = false;
            }
          });
        }
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getToArea();
    this.getMobile();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.loginBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 60px 22px 20px 22px;
  .t1 {
    font-size: 26px;
    color: #333;
    font-weight: bold;
  }
  .t2 {
    margin-top: 7px;
    color: #667280;
    font-size: 13px;
  }
  .userInfo {
    margin-top: 6px;
    background: #fff;
    .u1 {
      margin-top: 24px;
      font-size: 17px;
      color: #333;
      font-weight: 600;
    }
    .u2 {
      margin-top: 12px;
      width: 100%;
      height: 48px;
      line-height: 24px;
      background: #f0f2f3;
      border-radius: 8px 8px 8px 8px;
      padding-left: 15px;
      font-size: 15px;
      display: flex;
      align-items: center;
      border: 0 !important;
    }
    .yzm {
      padding-right: 100px !important;
    }
    .yzBox {
      position: relative;
      .yzBtn {
        position: absolute;
        top: 9px;
        right: 15px;
        width: 80px;
        height: 30px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #4076f6;
        text-align: center;
        line-height: 30px;
        color: #4076f6;
        font-size: 11px;
      }
    }
  }
  .btn {
    width: 100%;
    margin-top: 30px;
    height: 48px;
    background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
    box-shadow: 0px 6px 12px 0px #c5d6ff;
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    line-height: 48px;
    color: #ffffff;
    font-size: 15px;
  }
  .zc {
    width: 100%;
    margin-top: 20px;
    color: #4076f6;
    font-size: 15px;
    display: flex;
    align-items: center;
  }
}
.imgCodeBox {
  width: 300px;
  background: #ffffff;
  padding: 30px 28px 33px 28px;
  .i1 {
    text-align: center;
    color: #333333;
    font-size: 16px;
    font-weight: 600;
  }
  .imgCodeFlex {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .imgCode {
      width: 171px;
      height: 57px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 8px 8px 8px 8px;
      }
    }
    .sx {
      width: 66px;
      height: 57px;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: center;
      background: #f0f2f3;
      .sxImg {
        margin-top: 7px;
        width: 20px;
        height: 20px;
        margin-left: 3px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .sxt {
        margin-top: 5px;
        color: #666666;
        font-size: 13px;
      }
    }
  }
  .imgCodeInput {
    margin-top: 20px;
    .codeInput {
      width: 245px;
      height: 48px;
      background: #f0f2f3;
      border-radius: 8px 8px 8px 8px;
      border: 0 !important;
      padding: 0 15px;
    }
  }
  .qd {
    margin-top: 20px;
    border-radius: 8px;
    width: 245px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
  }
}
.headerNav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333;
}
</style>
